<template>
  <div class="app">
    <div class="top">
      <div class="topleft"></div>
      <bigtime :topData="topData"/>
      <div class="topright">
        <toptime/>
      </div>
    </div>
    <div class="left">
      <count :topLeftData="topLeftData"/>
      <goodstop :chartObjLeft2="chartObjLeft2"/>
      <carrying :chartObjLeft3="chartObjLeft3"/>
    </div>
    <div class="main">
      <Map :chartMap="chartMap" :chartMapfly="chartMapfly" :chartMapcolor="chartMapcolor"/>
    </div>
    <div class="right">
      <carriage :rightChart1="rightChart1"/>
      <Carrytop :chartObjRight2="chartObjRight2"/>
      <capacity-polyline :chartObjRight3="chartObjRight3"/>
    </div>
  </div>
</template>

<script>
import { parseMonth } from "../utils/paser";
import Map from "@/components/Map";
import goodstop from "@/components/goodstop";
import Carrying from "@/components/Carrying";
import CapacityPolyline from "@/components/CapacityPolyline";
import toptime from "@/components/toptime";
import bigtime from "@/components/bigtime";
import count from "@/components/count";
import Carrytop from "@/components/Carrytop";
import carriage from "@/components/carriage";
export default {
  name: "Main",
  components: {
    Map,
    goodstop,
    CapacityPolyline,
    Carrying,
    toptime,
    bigtime,
    count,
    Carrytop,
    carriage
  },
  data () {
    return {
      chartMap: {
        allPointData: {}
      },
      chartMapfly: {
        dataErr: []
      },
      chartMapcolor: {
        colorData: []
      },
      topData: {
        d: "-", // 在线
        e: "-", // 空车
        f: "-", //在途
        g: "-", //离线
        h: "000000000"
      },
      topLeftData: {
        totalCapacity: 0,
        totalFleet: 0,
        totalOrder: 0
      },
      rightChart1: {
        currentData: []
      },
      chartObjLeft2: {
        yData: [],
        seriesData: [],
        newSeriesData: []
      },
      chartObjLeft3: {
        dataList: [],
        dataNameList: []
      },
      chartObjRight2: {
        yData: [],
        seriesData: []
      },
      chartObjRight3: {
        timeList: [],
        dataList: [[], [], []]
      },
      citycolor: [
        { value: 1, color: "#ce4e21" },
        { value: 2, color: "#e46c47" },
        { value: 3, color: "#be49ac" },
        { value: 4, color: "#dfb31c" },
        { value: 5, color: "#27a16f" },
        { value: 6, color: "#322258" },
        { value: 7, color: "#102960" }
      ],
      citydata: [
        { value: 1, name: "安徽" },
        { value: 2, name: "澳门" },
        { value: 3, name: "北京" },
        { value: 4, name: "福建" },
        { value: 5, name: "甘肃" },
        { value: 6, name: "广东" },
        { value: 7, name: "关西" },
        { value: 8, name: "贵州" },
        { value: 9, name: "海南" },
        { value: 10, name: "河北" },
        { value: 11, name: "河南" },
        { value: 12, name: "黑龙江" },
        { value: 13, name: "湖北" },
        { value: 14, name: "湖南" },
        { value: 15, name: "吉林" },
        { value: 16, name: "江苏" },
        { value: 17, name: "江西" },
        { value: 18, name: "辽宁" },
        { value: 19, name: "内蒙古" },
        { value: 20, name: "宁夏" },
        { value: 21, name: "青海" },
        { value: 22, name: "山东" },
        { value: 23, name: "山西" },
        { value: 24, name: "陕西" },
        { value: 25, name: "上海" },
        { value: 26, name: "四川" },
        { value: 27, name: "台湾" },
        { value: 28, name: "天津" },
        { value: 29, name: "西藏" },
        { value: 30, name: "香港" },
        { value: 31, name: "新疆" },
        { value: 32, name: "云南" },
        { value: 33, name: "浙江" },
        { value: 34, name: "重庆" }
      ]
    };
  },
  created () {
    this.init();
  },
  mounted () { },
  methods: {
    init () {
      this.initWebSocket(); //websokeet
    },
    initWebSocket () {
      //初始化weosocket(必须)
      const wsuri = "ws://49.4.68.207:5080/websocket"; //请根据实际项目需要进行修改
      this.websock = new WebSocket(wsuri); //新建一个webstock对象
      this.websock.onmessage = this.wsOnmessage;
      this.websock.onopen = this.wsOnopen;
      this.websock.onerror = this.wsOnerror;
      this.websock.onclose = this.wsClose;
    },
    wsOnopen () {
      this.websock.send(
        JSON.stringify({
          c: 1,
          d: {
            a: 111,
            b: 1000,
            c: 1000,
            k: 1,
            d: [1, 2, 3, 4, 5, 6, 7, 8, 9],
            e: "aaaaaaaaaaaa"
          }
        })
      );
      console.log("连接成功");
    },
    wsOnerror () {
      //连接建立失败重连
      this.initWebSocket();
    },
    wsOnmessage (err) {
      //数据接收
      // console.log(err.data)
      let dataErr = JSON.parse(err.data);
      // console.log(dataErr.c, dataErr.d)
      if (dataErr.c === 8) {
        this.chartObjRight3.dataList = [[], [], []];
        this.chartObjRight3.timeList = [];

        dataErr.d.map(item => {
          this.chartObjRight3.timeList.push(parseMonth(item.a));
          this.chartObjRight3.dataList[0].push(item.b);
          this.chartObjRight3.dataList[1].push(item.c);
          this.chartObjRight3.dataList[2].push(item.d);
        });
        // this.renderChart(this.time, this.dataList)
      } else if (dataErr.c === 9) {
        if (typeof (dataErr.a) === "string") {
          this.topLeftData.totalCapacity = 0; //总运力
          this.topLeftData.totalFleet = 0; //总车队
          this.topLeftData.totalOrder = 0; // 总订单
          this.topData.d = "-";
          this.topData.e = "-";
          this.topData.f = "-";
          this.topData.g = "-";
          this.topData.h = '0000'
        } else {
          this.topLeftData.totalCapacity = dataErr.d[0].b; //总运力
          this.topLeftData.totalFleet = dataErr.d[0].c; //总车队
          this.topLeftData.totalOrder = dataErr.d[0].a; // 总订单
          this.topData.d = dataErr.d[0].d;
          this.topData.e = dataErr.d[0].e;
          this.topData.f = dataErr.d[0].f;
          this.topData.g = dataErr.d[0].g;
          this.topData.h = dataErr.d[0].h
        }
      } else if (dataErr.c === 1) {
        if (typeof (dataErr.a) === "string") {
          this.rightChart1.currentData = [
            { a: "auv", b: 100000 },
            { a: "跃云", b: 100000 },
            { a: "有车速报", b: 100000 },
            { a: "旭阳", b: 100000 },
          ]
        } else {
          this.rightChart1.currentData = dataErr.d;
          let newSeriesData = []
          dataErr.d.forEach(item => {
            newSeriesData.push(item.b)
          })
          this.chartObjLeft2.newSeriesData = newSeriesData
          // console.log(dataErr.d)
          // console.log(this.chartObjLeft2.newSeriesData)
        }
      } else if (dataErr.c == 2) {
        let newdata = [];
        dataErr.d.forEach(item => {
          newdata.push({
            name: item.a,
            value: item.b
          });
        });
        // 去重
        function deWeight () {
          for (var i = 0; i < newdata.length - 1; i++) {
            for (var j = i + 1; j < newdata.length; j++) {
              if (newdata[i].name == newdata[j].name) {
                newdata.splice(j, 1);
                //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
                j--;
              }
            }
          }
          return newdata;
        }
        var newtopdata = deWeight();
        // 排序
        function compare (pro) {
          return function (obj1, obj2) {
            var val1 = obj1[pro];
            var val2 = obj2[pro];
            if (val1 < val2) {
              //正序
              return 1;
            } else if (val1 > val2) {
              return -1;
            } else {
              return 0;
            }
          };
        }
        newtopdata.sort(compare("value"));
        let yData = [];
        let seriesData = [];
        newtopdata.forEach(item => {
          yData.push(item.name);
          seriesData.push((item.value / 1000).toFixed(0));
        });
        //后台数据文字长度控制
        yData = yData.map(item => {
          if (item.length > 3) {
            item = item.slice(0, 3) + "...";
          }
          return item;
        });
        this.chartObjLeft2.yData = yData;
        this.chartObjLeft2.seriesData = seriesData;
      } else if (dataErr.c == 3) {
        let newdata = [];
        dataErr.d.forEach(item => {
          newdata.push({
            name: item.a,
            value: item.b
          });
        });
        // 去重
        function deWeight () {
          for (var i = 0; i < newdata.length - 1; i++) {
            for (var j = i + 1; j < newdata.length; j++) {
              if (newdata[i].name == newdata[j].name) {
                newdata.splice(j, 1);
                //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
                j--;
              }
            }
          }
          return newdata;
        }
        var newtopdata = deWeight();
        // 排序
        function compare (pro) {
          return function (obj1, obj2) {
            var val1 = obj1[pro];
            var val2 = obj2[pro];
            if (val1 < val2) {
              //正序
              return 1;
            } else if (val1 > val2) {
              return -1;
            } else {
              return 0;
            }
          };
        }
        newtopdata.sort(compare("value"));
        let yData = [];
        let seriesData = [];
        newtopdata.forEach(item => {
          yData.push(item.name);
          seriesData.push(item.value);
        });
        //后台数据文字长度控制
        yData = yData.map(item => {
          if (item.length > 3) {
            item = item.slice(0, 3) + "...";
          }
          return item;
        });
        this.chartObjRight2.yData = yData;
        this.chartObjRight2.seriesData = seriesData;
      } else if (dataErr.c == 7) {
        // console.log(dataErr.d)
        if (typeof (dataErr.a) === "string") {
          this.chartObjLeft3.dataList = [1000, 1000, 1000, 1000];
          this.chartObjLeft3.dataNameList = ["AUV", "跃云", "有车速报", "旭阳"]
        } else {
          let dataList = [];
          let dataNameList = []
          dataErr.d.forEach(item => {
            dataList.push(item.b);
            dataNameList.push(item.a)
          });
          this.chartObjLeft3.dataList = dataList;
          this.chartObjLeft3.dataNameList = dataNameList
        }
      } else if (dataErr.c == 6) {
        // console.log('散点数据', dataErr.c)
        const data1 = {};
        dataErr.d.forEach(item => {
          data1[item.a] = [item.b / 1000000, item.c / 1000000];
        });
        this.chartMap.allPointData = {
          ...this.chartMap.allPointData,
          ...data1
        }; // 缓存散点数据，并去重
      } else if (dataErr.c == 5) {
        this.chartMapfly.dataErr = dataErr.d;
      } else if (dataErr.c == 4) {
        // console.log(dataErr.d)
        dataErr.d.forEach(item => {
          let wsCityValue = item.a; //获取到的后台城市value
          let wsColorValue = item.c; //获取到的后台颜色value
          this.citycolor.forEach(item => {
            let colorValue = item.value;
            let colorCity = item.color;
            //循环筛选城市
            this.citydata.forEach(item => {
              let cityValue = item.value; //城市value
              let cityName = item.name; //城市名
              if (wsCityValue == cityValue && wsColorValue == colorValue) {
                //将符合数据的城市名push进colordata
                this.chartMapcolor.colorData.push({
                  name: cityName,
                  color: colorCity
                });
              }
            });
          });
        });
      }
    }
  }
};
</script>

<style scoped>
.app {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-image: url('../assets/img/bg/运力大屏bg.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: 100% 100%;
}
.top {
  width: 100%;
  height: 15%;
  display: flex;
}
.top .topleft {
  width: 25%;
  height: 100%;
  background-image: url('../assets/img/bg/左上.png');
  background-repeat: no-repeat;
  background-size: top;
}
.top .topright {
  width: 25%;
  height: 100%;
  background-image: url('../assets/img/bg/右上bg.png');
  background-repeat: no-repeat;
  background-position: top right;
  position: relative;
}
.left {
  float: left;
  width: 24%;
  height: 85%;
  margin-left: 1%;
}
.main {
  float: left;
  width: 50%;
  height: 85%;
}
.right {
  float: left;
  width: 24%;
  height: 85%;
  margin-right: 1%;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue